import { formatRating } from '../../utils/rating';
import StorageNavItem from '../../storage/StorageNavItem';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import { Avatar, Badge, Box, Button, Card, CardActions, CardContent, Chip, Divider, Drawer, IconButton, Input, LinearProgress, Link, List, ListItem, ListItemButton, listItemButtonClasses, ListItemContent, ListItemDecorator, Sheet, Stack, Tooltip, Typography, useTheme } from "@mui/joy";

import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CachedRoundedIcon from '@mui/icons-material/CachedRounded';
import TableChartRoundedIcon from '@mui/icons-material/TableChartRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import ArchitectureRoundedIcon from '@mui/icons-material/ArchitectureRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
import CreditCardRoundedIcon from '@mui/icons-material/CreditCardRounded';
import InsertCommentRoundedIcon from '@mui/icons-material/InsertCommentRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import AccessibilityNewRoundedIcon from '@mui/icons-material/AccessibilityNewRounded';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import ContactSupportRoundedIcon from '@mui/icons-material/ContactSupportRounded';
import NotificationsIcon from '@mui/icons-material/Notifications';
import BookRoundedIcon from '@mui/icons-material/BookRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import InboxRoundedIcon from '@mui/icons-material/InboxRounded';
import FlagRoundedIcon from '@mui/icons-material/FlagRounded';
import PaymentsRoundedIcon from "@mui/icons-material/PaymentsRounded";
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded';
import DesignServicesRoundedIcon from '@mui/icons-material/DesignServicesRounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded';
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import CampaignRoundedIcon from "@mui/icons-material/CampaignRounded";
import TerminalRoundedIcon from '@mui/icons-material/TerminalRounded';
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';

import { motion, AnimatePresence } from "framer-motion";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useContext, useEffect, useMemo, useState } from "react";
import { LayoutContext } from "../../context";
import { Link as RouterLink, useLocation, useNavigate } from "react-router";
import Cookies from "js-cookie";
import { API_URL, APIGetEvents, APIGetPaymentEvent, APIGetStatistics } from "../../api";
import { closeSidebar } from "../../utils";
import SwitchRoleButton from "./SwitchRoleButton";
import { canAccessPath } from "../../roles";



export default function Sidebar() {
    const { checkNotificationStatus, sidebarOpen, setSidebarOpen, tokenEmployee, subscribeUserToPush, totalUnread, setTokenEmployee, setModalProfile } = useContext(LayoutContext);
    const { account, effectiveRole, setAccount, setLock, setModalEvent, setModalTicketSupport, unassignedAppsCount, pendingPerformersCount, notifUnread, setNotifPanelOpen } = useContext(LayoutContext);

    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [ isViewStat, setIsViewStat ] = useState(true);

    // Можно ли показать пункт по ролям (нет roles => показываем всем)
    const canSee = (path) => canAccessPath(path, { account, activeRole: effectiveRole });

    // Разделы меню (категории с подпунктами)
    const NAV_SECTIONS = [
        {
            key: 'main',
            title: 'Основное',
            items: [
                { label: 'Календарь', icon: <CalendarMonthRoundedIcon/>, path: '/' },
                // { label: 'Сделки чертежников', icon: <ArchitectureRoundedIcon/>, path: '/draftsman', roles: ['quality_master'] },
                { label: 'Заявки клиентов', icon: <InboxRoundedIcon/>, path: '/applications', badge: unassignedAppsCount },
                { label: 'Чаты', icon: <InsertCommentRoundedIcon/>, path: '/chats', badge: totalUnread },
            ],
        },
        {
            key: 'finance',
            title: 'Финансы',
            items: [
                { label: 'Дашборд', icon: <InsightsRoundedIcon/>, path: '/finance', roles: ['head_manager'] },
                { label: 'Платежи', icon: <CreditCardRoundedIcon/>, path: '/payments' },
                { label: 'Платежи клиентов', icon: <PaymentsRoundedIcon/>, path: '/client-payments', roles: ['manager', 'head_manager'] },
                { label: 'Услуги и тарифы', icon: <DesignServicesRoundedIcon/>, path: '/services-tariffs', roles: ['manager', 'head_manager'] },
            ],
        },
        {
            key: 'goals',
            title: 'Цели',
            items: [
                { label: 'Цели', icon: <FlagRoundedIcon/>, path: '/goals', roles: ['manager', 'head_manager'] },
                { label: 'Цели качества', icon: <VerifiedRoundedIcon/>, path: '/quality-goals', roles: ['quality_master', 'head_manager'] },
            ],
        },
        {
            key: 'extra',
            title: 'Дополнительно',
            items: [
                { label: 'Клиенты', icon: <PeopleAltRoundedIcon/>, path: '/clients', roles: ['manager', 'head_manager'] },
                { label: 'Документы', icon: <DescriptionRoundedIcon/>, path: '/documents', roles: ['manager', 'head_manager'] },
                { label: 'Исполнители', icon: <AccessibilityNewRoundedIcon/>, path: '/performers', badge: pendingPerformersCount },
                { label: 'Статистика', icon: <AssessmentRoundedIcon/>, path: '/statistics' },
                { label: 'База знаний', icon: <BookRoundedIcon/>, path: '/knowledge' },
                { label: 'Новости', icon: <CampaignRoundedIcon/>, path: '/news', roles: ['head_manager'] },
                { label: 'Логи', icon: <TerminalRoundedIcon/>, path: '/activity-logs', roles: ['head_manager'] },
                { label: 'Доступы', icon: <AdminPanelSettingsRoundedIcon/>, path: '/access' },
                { label: 'Настройки', icon: <SettingsRoundedIcon/>, path: '/settings' },
            ],
        },
    ];

    const [openSections, setOpenSections] = useState({ main: true, finance: true, goals: true, extra: true });

    // Авто-раскрытие раздела, в котором лежит активный путь
    useEffect(() => {
        const sec = NAV_SECTIONS.find(s => s.items.some(it => it.path === location.pathname));
        if (sec) setOpenSections(prev => ({ ...prev, [sec.key]: true }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    function isCheckStat() {
        if (window.screen.height > 750) return setIsViewStat(true);
        else setIsViewStat(false);
    };

    useEffect(() => {
        window.addEventListener("resize", isCheckStat);
        isCheckStat();
        return () => {
            window.removeEventListener("resize", isCheckStat);
        };
    }, []);

    function clsBar() {
        closeSidebar();
        setSidebarOpen(false);
    }
    
    function handlerExitClick () {
        Cookies.remove("auth_token"); // Удаляем токен из cookies
        Cookies.remove("auth_token_employee"); // Удаляем токен из cookies
        // Cookies.remove("active_role"); // Ужаляем токен об выборе профиля из cookies
        localStorage.removeItem('active_role');

        setLock(true);
        setAccount({});
        setTokenEmployee(null);
    }

    const handleDateClick = () => {
        setModalEvent({ event: null, open: true });
    };

    // Подгружаем события
    // function updateListEvents() {
    //     APIGetEvents().then((data) => {
    //         if (data?.length) {
    //             console.log("Events", data);
    //             setListEvents(data);
    //         }
    //     })
    // }



    const [ showInstallPrompt, setShowInstallPrompt ] = useState(false);
    // Проверяем, нужно ли показывать кнопку для iOS
    useEffect(() => {
        const checkiOSRequirements = () => {
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            
            if (isIOS && isSafari) {
                // Проверяем, установлено ли как PWA
                const isStandalone = window.navigator.standalone;
                const isInstalled = window.matchMedia('(display-mode: standalone)').matches;
                
                if (!isStandalone && !isInstalled) {
                    setShowInstallPrompt(true);
                }
            }
        };
        
        checkiOSRequirements();
    }, []);
    
    const handleEnableNotifications = async () => {
        if (tokenEmployee) {
            const result = await subscribeUserToPush(tokenEmployee);
            
            // Если iOS и нужно установить PWA
            if (result?.type === 'ios_need_install') {
                alert('Для получения уведомлений на iPhone:\n\n1. Нажмите кнопку "Поделиться" (в нижней панели Safari)\n2. Выберите "На экран \"Домой\""\n3. Откройте приложение с домашнего экрана');
            }
        }
    };
    
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isStandalone = window.navigator.standalone || 
                         window.matchMedia('(display-mode: standalone)').matches;


    return (
        <Box>
            <AnimatePresence>
                { sidebarOpen && (
                    <motion.div
                        key="sidebar-overlay"
                        initial={{ backdropFilter: "blur(0px)", backgroundColor: '#555e6800' }}
                        animate={{ backdropFilter: "blur(5px)", backgroundColor: '#555e686b' }}
                        exit={{ backdropFilter: "blur(0px)", backgroundColor: '#555e6800' }}
                        transition={{ 
                            duration: 0.2,
                            ease: "easeInOut"
                        }}
                        style={{
                            position: 'fixed',
                            zIndex: 9999,
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            // opacity: '0.4',
                            // backdropFilter: "blur(5px)",
                            // backgroundColor: '#555e687d',
                            // transition: 'opacity 0.4s',
                            // transform: {
                            //     xs: 'translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1) + var(--SideNavigation-slideIn, 0) * var(--Sidebar-width, 0px)))',
                            //     md: 'translateX(-100%)',
                            // },
                        }}
                        onClick={() => clsBar()}
                    />
                )}
                
            </AnimatePresence>

            <Sheet
                className="Sidebar"
                sx={{
                    position: { xs: 'fixed', md: 'sticky' },
                    transform: {
                        xs: 'translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1)))',
                        md: 'none',
                    },
                    transition: 'transform 0.4s, width 0.4s',
                    zIndex: 10000,
                    height: '-webkit-fill-available',
                    // height: '100dvh',
                    width: '240px',
                    top: 0,
                    p: 2,
                    flexShrink: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 0,
                    borderRight: '1px solid',
                    borderColor: 'divider',
                }}
            >
                <Stack spacing={0} direction={"row"} sx={{ alignItems: 'flex-start', justifyContent: 'space-between' }}>
                    <Stack spacing={1} sx={{ p: 0.5 }} direction={"row"}>
                        <img style={{ width: 30 }} src="/logo191.jpg"/>
                        <Typography level="title-md">PLANIUM</Typography>
                    </Stack>
                    <Button sx={{ 
                        display: { xs: 'flex', md: 'none' }, 
                        p: 0.5 
                    }} size="sm" color="neutral" variant="plain" onClick={() => clsBar()}>
                        <CloseRoundedIcon sx={{ px: 0.4 }}/>
                    </Button>
                </Stack>
                

                <Stack direction={"column"} spacing={1.5} 
                    sx={{ 
                        mt: 2, 
                        minHeight: 0,
                        overflow: 'hidden auto',
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    {/* <Button color="primary" variant="soft" component="a" href={API_URL + '/admin/'} sx={{ mb: 1 }}>
                        Администрировать
                    </Button>
                    <Button onClick={handleDateClick} startDecorator={<AddRoundedIcon/>} color="warning" variant="soft">
                        Создать событие
                    </Button> */}
                    {/* { location.pathname == '/payments' ?
                        undefined
                        // <Button onClick={() => {
                        //     setListPaymentEvents([]);
                        //     getPaymentEvents();
                        // }} startDecorator={<CachedRoundedIcon/>} color="neutral" variant="soft">
                        //     Обновить список платежей
                        // </Button>
                        :
                        <Button onClick={() => updateListEvents(null, null)} startDecorator={<CachedRoundedIcon/>} color="neutral" variant="soft" sx={{ lineHeight: 1.1 }}>
                            Обновить список событий
                        </Button>
                    }
                    <Divider/> */}

                    <List size="sm" sx={{ '--ListItem-paddingY': '0.4rem', "--List-gap": "6px" }}>
                        <StorageNavItem />
                        {NAV_SECTIONS.map((section) => {
                            const items = section.items.filter(it => canSee(it.path));
                            if (items.length === 0) return null;
                            const open = openSections[section.key] ?? true;

                            return (
                                <Box key={section.key} sx={{ mb: 0.25 }}>
                                    {/* Заголовок категории */}
                                    <ListItemButton
                                        onClick={() => setOpenSections(prev => ({ ...prev, [section.key]: !open }))}
                                        sx={{ borderRadius: 'lg', px: 1.5, py: 0.5 }}
                                    >
                                        <ListItemContent>
                                            <Typography level="body-xs" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'text.tertiary' }}>
                                                {section.title}
                                            </Typography>
                                        </ListItemContent>
                                        <KeyboardArrowDownRoundedIcon
                                            sx={{ color: 'text.tertiary', transition: 'transform .2s', transform: open ? 'rotate(0deg)' : 'rotate(-90deg)' }}
                                        />
                                    </ListItemButton>

                                    {/* Подпункты */}
                                    <AnimatePresence initial={false}>
                                        {open && (
                                            <motion.div
                                                initial={{ height: 0, opacity: 0 }}
                                                animate={{ height: 'auto', opacity: 1 }}
                                                exit={{ height: 0, opacity: 0 }}
                                                transition={{ duration: 0.18 }}
                                                style={{ overflow: 'hidden' }}
                                            >
                                                <List size="sm" sx={{ "--List-gap": "6px", pl: 0.5, mt: 0.25 }}>
                                                    {items.map((it) => {
                                                        const active = location.pathname === it.path;
                                                        const itemNode = (
                                                            <ListItem sx={{ width: '100%', borderColor: 'divider', display: 'flex', justifyContent: 'space-between' }}>
                                                                <ListItemButton
                                                                    variant="soft"
                                                                    color={active ? 'primary' : 'neutral'}
                                                                    onClick={() => { navigate(it.path, { replace: true }); clsBar(); }}
                                                                    sx={{ lineHeight: 1.1, px: 2, borderRadius: 'lg' }}
                                                                >
                                                                    <ListItemDecorator>{it.icon}</ListItemDecorator>
                                                                    <ListItemContent>{it.label}</ListItemContent>
                                                                    <KeyboardArrowRightRoundedIcon/>
                                                                </ListItemButton>
                                                            </ListItem>
                                                        );

                                                        return it.badge ? (
                                                            <Badge
                                                                key={it.path}
                                                                badgeContent={it.badge}
                                                                color="danger"
                                                                size="sm"
                                                                sx={{ width: '100%', "& .MuiBadge-badge": { mr: 1, mt: 1 } }}
                                                            >
                                                                {itemNode}
                                                            </Badge>
                                                        ) : (
                                                            <Box key={it.path}>{itemNode}</Box>
                                                        );
                                                    })}
                                                </List>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </Box>
                            );
                        })}
                    </List>


                    {/* { location.pathname == '/payments' ?
                        <Button color="primary" startDecorator={<CalendarMonthRoundedIcon/>} variant="soft" onClick={() => navigate('/', { replace: true })} sx={{ mb: 1 }}>
                            Календарь
                        </Button>
                        :
                        <Button color="primary" startDecorator={<TableChartRoundedIcon/>} variant="soft" onClick={() => navigate('/payments', { replace: true })} sx={{ mb: 1 }}>
                            Платежи
                        </Button>
                    } */}
                    
                    {/* <Button color="primary" startDecorator={<CalendarMonthRoundedIcon/>} variant="soft" onClick={() => navigate('/', { replace: true })} sx={{ mb: 1 }}>
                        Календарь
                    </Button>
                    { account?.position?.includes('quality_master') && (
                        <Button color="primary" startDecorator={<ArchitectureRoundedIcon/>} variant="soft" onClick={() => navigate('/draftsman', { replace: true })} sx={{ mb: 1 }}>
                            Черчение
                        </Button>
                    )}
                    <Button color="primary" startDecorator={<CreditCardRoundedIcon/>} variant="soft" onClick={() => navigate('/payments', { replace: true })} sx={{ mb: 1 }}>
                        Платежи
                    </Button>
                    <Button color="primary" startDecorator={<AssessmentRoundedIcon/>} variant="soft" onClick={() => navigate('/statistics', { replace: true })} sx={{ mb: 1 }}>
                        Статистика
                    </Button>
                    <Button color="primary" startDecorator={<AccessibilityNewRoundedIcon/>} variant="soft" onClick={() => navigate('/performers', { replace: true })} sx={{ mb: 1 }}>
                        Исполнители
                    </Button>
                    <Badge badgeContent={totalUnread} color="danger" 
                        sx={{ width: '100%',
                            "& .MuiBadge-badge": {
                                mr: 2.5
                            }
                        }}
                    >
                        <Button color="primary" startDecorator={<InsertCommentRoundedIcon/>} variant="soft" onClick={() => navigate('/chats', { replace: true })} sx={{ mb: 1, width: '100%' }}>
                            Чаты
                        </Button>
                    </Badge> */}
                </Stack>
                
                { isViewStat && (
                    <MiniStatsWidget tokenEmployee={tokenEmployee}/>
                )}

                <Divider sx={{ mb: 1 }} />

                <Stack direction={"row"} alignItems={'center'} spacing={0.5} sx={{ width: "-webkit-fill-available", maxWidth: 200 }}>
                    <Box
                        onClick={(e) => setModalProfile(true)}
                        sx={{
                            display: 'flex', gap: 1, alignItems: 'center',
                            cursor: 'pointer',
                            p: 1, maxWidth: 190,
                            borderRadius: 'lg',
                            transition: 'background 0.15s',
                            '&:hover': { bgcolor: 'neutral.softBg' }
                        }}
                    >
                        <Avatar
                            variant="outlined"
                            size="sm"
                            src="/smile.png"
                            sx={{ 
                                p: .3,
                                "& > img": {
                                width: 25,
                                height: 'auto'
                                }
                            }}
                        />
                        <Stack sx={{ minWidth: 0, flex: 1 }} spacing={0.5}>
                            <Chip 
                                variant="soft" 
                                color="primary" 
                                endDecorator={<StarRoundedIcon sx={{ color: '#e8d221' }} />} 
                                sx={{ my: 1 }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography level="body-sm">Рейтинг:</Typography>
                                    <Typography level="body-sm" color="primary" >
                                        {formatRating(account?.reviews?.statistics.average_rating)}
                                    </Typography>
                                </Box>
                            </Chip>
                            
                            <Typography level="title-sm" noWrap={'nowrap'} sx={{ lineHeight: 1.1 }}>{account?.last_name} {account?.name}</Typography>
                            <Typography noWrap level="body-xs" sx={{ lineHeight: 1.1 }}>{account?.email}</Typography>
                        </Stack>
                    </Box>
                    <Stack direction="column" spacing={0.5}>
                        <SwitchRoleButton />
                        <IconButton onClick={handlerExitClick} xs={{ height: "fit-content" }} size="sm" variant="soft" color="danger">
                            <ExitToAppRoundedIcon />
                        </IconButton>
                    </Stack>
                    
                </Stack>
            </Sheet>
        </Box>
    );
}




const MiniStatsWidget = ({ tokenEmployee }) => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [collapsed, setCollapsed] = useState(false);

    const fetchStats = async () => {
        const date = new Date();
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
        const params = { date_from: firstDay, date_to: lastDay };

        setLoading(true);
        try {
            const statsData = await APIGetStatistics(params, Cookies.get("auth_token") || tokenEmployee);
            setStats(statsData);
        } catch (error) {
            console.error("Ошибка загрузки данных:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchStats(); }, []);

    const metrics = [
        { label: 'Назначено', value: stats?.assigned },
        { label: 'Закрыто обмеров', value: stats?.closed_measurements },
        { label: 'Завершено чертежей', value: stats?.completed_drawings },
        { label: 'Ср. время обмера', value: stats?.avg_measurement_time?.toFixed(2) },
        { label: 'Ср. время черчения', value: stats?.avg_drawing_time?.toFixed(2) },
    ];

    return (
        <Card variant="plain" color="primary" invertedColors sx={{ mb: 2, p: 1, borderRadius: 'lg', gap: 0.5 }}>
            {/* Заголовок со сворачиванием */}
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ cursor: 'pointer' }}
                onClick={() => setCollapsed(c => !c)}
            >
                <Typography level="title-sm" sx={{ fontWeight: 700 }}>Статистика за месяц</Typography>
                <IconButton
                    size="sm"
                    variant="plain"
                    color="neutral"
                    onClick={(e) => { e.stopPropagation(); setCollapsed(c => !c); }}
                >
                    <KeyboardArrowDownRoundedIcon
                        sx={{ transition: 'transform .2s', transform: collapsed ? 'rotate(-90deg)' : 'rotate(0deg)' }}
                    />
                </IconButton>
            </Stack>

            <AnimatePresence initial={false}>
                {!collapsed && (
                    <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.18 }}
                        style={{ overflow: 'hidden' }}
                    >
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: 1, rowGap: 0.5, mt: 0.5 }}>
                            {metrics.map((m) => (
                                <Box key={m.label} sx={{ display: 'flex', flexDirection: 'column', lineHeight: 1.1 }}>
                                    <Typography level="body-xs" sx={{ opacity: 0.8 }}>{m.label}</Typography>
                                    <Typography level="title-sm" sx={{ fontWeight: 700 }}>{m.value ?? '—'}</Typography>
                                </Box>
                            ))}
                        </Box>

                        <Button variant="soft" size="sm" onClick={fetchStats} disabled={loading} sx={{ mt: 1, width: '100%' }}>
                            {loading ? 'Загрузка...' : 'Обновить'}
                        </Button>
                    </motion.div>
                )}
            </AnimatePresence>
        </Card>
    );
};